var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUrl = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "URL",
  fill: "#3A414C",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.71,12.5 C4.71,10.961 5.961,9.71 7.5,9.71 L11.1,9.71 L11.1,8 L7.5,8 C5.016,8 3,10.016 3,12.5 C3,14.984 5.016,17 7.5,17 L11.1,17 L11.1,15.29 L7.5,15.29 C5.961,15.29 4.71,14.039 4.71,12.5 Z M8.4,13.4 L15.6,13.4 L15.6,11.6 L8.4,11.6 L8.4,13.4 Z M16.5,8 L12.9,8 L12.9,9.71 L16.5,9.71 C18.039,9.71 19.29,10.961 19.29,12.5 C19.29,14.039 18.039,15.29 16.5,15.29 L12.9,15.29 L12.9,17 L16.5,17 C18.984,17 21,14.984 21,12.5 C21,10.016 18.984,8 16.5,8 Z",
  id: "Shape"
})))));
export { SvgUrl as ReactComponent };
export default __webpack_public_path__ + "static/media/url.38db3ab6.svg";